// extracted by mini-css-extract-plugin
export default {"centered":"_2r21F","unsubscribe-width":"_1bMDm","unsubscribeWidth":"_1bMDm"};